__turbopack_context__.v({
  "root": "PlasmicSliderBtn-module__n5VSOa__root",
  "rootglobal_themeOrange_override": "PlasmicSliderBtn-module__n5VSOa__rootglobal_themeOrange_override",
  "rootglobal_themeOrange_override_inactive": "PlasmicSliderBtn-module__n5VSOa__rootglobal_themeOrange_override_inactive",
  "rootinactive": "PlasmicSliderBtn-module__n5VSOa__rootinactive",
});
